import isArray from 'lodash/isArray.js';
import Model from '@/entities/Model.js';
import Account from '@/entities/Account.js';

export default class User extends Model {
    static get defaults() {
        return {
            account_id: null,

            email: null,
            first_name: null,
            last_name: null,

            // Belongs to
            _account: new Account(),
        };
    }

    /**
     * Constants
     */
    static get ADMIN_USER() {
        return 1;
    }

    get account() {
        return this._account;
    }

    set account(value) {
        if (value) {
            this._account = new Account(value);
            this.account_id = value.id;
        }
    }

    get fullName() {
        return `${this.first_name || ''} ${this.last_name || ''}`.trim();
    }

    can(permissions) {
        if (!this.permissions) {
            return false;
        }

        if (!isArray(permissions)) {
            permissions = [permissions];
        }

        return this.permissions.some(permission => {
            return permissions.includes(permission.name);
        });
    }
}
